const messages = {
	en: {
		translations: {
			selectLanguage: "Select Language",
			allTicket: {
				form: {
					viewTags: "All tickets",
				},
			},
			signup: {
				title: "Sign Up",
				toasts: {
					success: "User created successfully! Please login!!!",
					fail: "Error creating user. Please check the provided information.",
				},
				form: {
					name: "Company Name",
					cpfCnpj: "CPF/CNPJ",
					email: "Email",
					phone: "Phone Number (with Area Code)",
					plan: "Plan",
					password: "Password",
				},
				formErrors: {
					cpfCnpj: {
						required: "CPF/CNPJ is required",
						invalid: "Invalid CPF/CNPJ",
					},
					name: {
						required: "Company name is required",
						short: "Name is too short",
						long: "Name is too long",
					},
					password: {
						short: "Password is too short",
						long: "Password is too long",
						required: "Password is required",
					},
					phone: {
						required: "Phone number is required",
					},
					plan: {
						required: "Plan is required",
					},
					email: {
						required: "Email is required",
						invalid: "Invalid email",
					},
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Login!",
				},
				plan: {
					attendant: "Attendant",
					whatsapp: "WhatsApp",
					queues: "Queues",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Login",
					register: "Sign up now!",
				},
			},
			resetPassword: {
				title: "Reset Password",
				toasts: {
					emailSent: "Email sent successfully!",
					emailNotFound: "Email not found!",
					passwordUpdated: "Password updated successfully!",
				},
				formErrors: {
					email: {
						required: "Email is required",
						invalid: "Invalid email",
					},
					newPassword: {
						required: "New password is required",
						matches: "Your password must have at least 8 characters, including one uppercase letter, one lowercase letter, and one number.",
					},
					confirmPassword: {
						required: "Password confirmation is required",
						matches: "Passwords do not match",
					},
				},
				form: {
					email: "Email",
					verificationCode: "Verification Code",
					newPassword: "New Password",
					confirmPassword: "Confirm New Password",
				},
				buttons: {
					submitEmail: "Send Email",
					submitPassword: "Reset Password",
					resendCode: "Resend code",
					resendCooldown: "Resend code in {{seconds}}s",
					back: "Don't have an account? Sign up!",
				},
			},
			dashboard: {
				pipelineWon: "Total Won",
				pipelineLost: "Total Lost",
				conversionRate: "Conversion Rate",
				toasts: {
					selectFilterError: "Set filter parameters",
					userChartError: "Error getting conversation information",
					dateChartError: "Error getting conversation information",
				},
				filters: {
					initialDate: "Start Date",
					finalDate: "End Date",
					kanbanBoard: "Kanban board",
					allKanbanBoards: "All boards",
					filterType: {
						title: "Filter Type",
						options: {
							perDate: "Filter by Date",
							perPeriod: "Filter by Period",
						},
						helper: "Select desired filter type",
					},
				},
				performanceIndicators: {
					axisLeft: "Left axis",
					axisRight: "Right axis",
					none: "None",
					tickets: "Tickets",
					wonCount: "Won count",
					lostCount: "Lost count",
					wonValue: "Revenue",
					conversionRate: "Conversion rate",
					avgSupportTime: "Average service time",
					avgConversionTime: "Average conversion time",
				},
				periodSelect: {
					title: "Period",
					options: {
						none: "None selected",
						last3: "Last 3 days",
						last7: "Last 7 days",
						last15: "Last 15 days",
						last30: "Last 30 days",
						last60: "Last 60 days",
						last90: "Last 90 days",
					},
					helper: "Select desired period",
				},
				counters: {
					inTalk: "In conversation",
					waiting: "Waiting",
					finished: "Finished",
					newContacts: "New contacts",
					averageTalkTime: "Avg. Talk Time",
					averageWaitTime: "Avg. Wait Time",
				},
				buttons: {
					filter: "Filter",
				},
				onlineTable: {
					ratingLabel: "1 - Unsatisfied, 2 - Satisfied, 3 - Very Satisfied",
					name: "Name",
					ratings: "Ratings",
					avgSupportTime: "Avg. Support Time",
					status: "Status (Current)",
				},
				charts: {
					user: {
						label: "Conversations Chart",
						title: "Total Conversations by Users",
						start: "Start",
						end: "End",
						filter: "Filter",
					},
					date: {
						label: "Conversations Chart",
						title: "Total",
						start: "Start",
						end: "End",
						filter: "Filter",
					},
				},
			},
			datePicker: { openDate: "Select date", openTime: "Select time", time: "Time", timeHint: "Enter the time as HH:mm", clear: "Clear", apply: "Apply" },
			plans: {
				newPlan: "New Plan",
				editPlan: "Edit Plan",
				registeredPlans: "Registered Plans",
				toasts: {
					errorList: "Could not load records list",
					errorOperation: "Could not complete operation",
					error: "Could not complete operation. Check if a plan with the same name already exists or if fields were filled correctly",
					success: "Operation completed successfully!",
				},
				confirm: {
					title: "Delete Record",
					message: "Do you really want to delete this record?",
				},
				form: {
					features: "Features",
					name: "Name",
					users: "Users",
					connections: "Connections",
					queues: "Queues",
					value: "Value",
					internalChat: "Internal Chat",
					externalApi: "External API",
					kanban: "Kanban",
					integrations: "Integrations",
					automation: "Automation",
					campaigns: "Campaigns",
					schedules: "Schedules",
					enabled: "Enabled",
					disabled: "Disabled",
					clear: "Cancel",
					delete: "Delete",
					save: "Save",
					yes: "Yes",
					no: "No",
					money: "$",
				},
			},
			activityAssignee: {
				title: "Activity assignee",
				noAssignee: "No assignee",
				ticketOwner: "Ticket owner",
				allUsers: "Everyone",
			},
			kanban: {
				toasts: {
					removed: "Ticket Tag Removed!",
					added: "Ticket Tag Added Successfully!",
					columnReordered: "Stage reordered successfully",
					reorderError: "Failed to reorder stage",
					permissionDenied: "No permission to reorder stages",
					columnDeleted: "Stage deleted successfully",
					archived: "Card archived successfully!",
					restored: "Card restored successfully!",
					resolvedWon: "Marked as Won!",
					resolvedLost: "Marked as Lost!",
				},
				outcome: {
					label: "Outcome",
					open: "Open",
					won: "Won",
					lost: "Lost",
					save: "Save outcome",
				},
				archiveOnResolve: "Archive when setting outcome",
				dropToWin: "Drop here to mark as Won",
				dropToLose: "Drop here to mark as Lost",
				dropToArchive: "Drop here to archive",
				dropToRemoveFromStage: "Drop here to remove from stage",
				dropToClose: "Drop here to close",
				dropToCloseAndRemove: "Drop here to close and remove",
				dropNoCardXAction: "No X action configured",
				drawer: {
					all: "All",
					won: "Won",
					lost: "Lost",
				},
				description: "Description",
				information: "Information",
				activity: "Comments and activity",
				noActivity: "No activity recorded",
				board: "Board",
				comment: {
					placeholder: "Write a comment",
				},
				column: {
					addTitle: "New Stage",
					deleteTitle: "Delete Stage",
					deleteMessage: "Are you sure you want to delete this stage?",
					options: "Stage Options"
				},
				boardModal: {
					title: {
						create: "New Board",
						edit: "Edit Board"
					},
					name: "Board Name",
					showCardCountCompact: "Card count",
					showCardValueSumCompact: "Value total",
					showCardCount: "Show Count",
					showCardValueSum: "Show Value Sum",
					isManualSorting: "Manual Sorting"
				},
				addColumn: "+ Add new stage",
				open: "Open",
				seeTicket: "View Ticket",
				selectBoard: "Select board",
				noBoards: "No boards available",
				createNew: "➕ Create new...",
				column: {
					addTitle: "New Stage",
					deleteTitle: "Delete stage",
					deleteMessage: "Are you sure you want to delete this stage{{name}}?",
					delete: "Delete stage",
					collapse: "Collapse stage",
					expand: "Expand stage",
					addTicket: "Add ticket/card",
				},
				actions: {
					new: "New",
					edit: "Edit",
					delete: "Delete",
				},
				boardModal: {
					new: "New board",
					edit: "Edit board",
					name: "Board name",
					cancel: "Cancel",
					save: "Save",
					create: "Create",
					showCardCountCompact: "Card count",
					showCardValueSumCompact: "Value total",
					showCardCount: "Card count",
					showCardValueSum: "Card value sum",
					isManualSorting: "Manual sorting",
					prioritizeUnread: "Unread",
					openTicketOnCardAdd: "Create new card with open ticket",
					showClosedTicketsInArchived: "Show closed tickets in archived",
					enableOutcomeTracking: "CRM Mode",
					showCardTags: "Tags on cards",
					showCardPhone: "Phone on cards",
					showCardLastMessage: "Last message on cards",
					showCardValue: "Value on cards",
					deleteTitle: "Delete board",
					deleteMessage: "Do you really want to delete this board? Tags linked to it will no longer be assigned to a kanban.",
					saved: "Board saved successfully.",
					deleted: "Board deleted successfully.",
					generalSettings: "General",
					displaySettings: "Display",
					tickets: "Tickets",
					cards: "Cards",
					tags: "Tags",
					phone: "Phone",
					lastMessage: "Last message",
					value: "Value",
					description: "Description",
				},
				archived: {
					title: "Archived",
					empty: "No archived items",
					restore: "Restore",
					restoreSuccess: "Card restored successfully!",
					ticketRestoreSuccess: "Ticket reopened successfully!",
					viewArchived: "View Archived",
					delete: "Delete permanently",
					archivedAt: "Archived at",
					archivedBy: "Archived by",
					card: "Card",
					ticket: "Ticket",
					closedTicket: "Closed ticket",
					reopenTicket: "Reopen ticket"
				},
			},
			invoices: {
				title: "Financial",
				paid: "Paid",
				open: "Open",
				expired: "Expired",
				details: "Details",
				value: "Amount",
				dueDate: "Due Date",
				status: "Status",
				action: "Action",
				PAY: "PAY",
				PAID: "PAID",
				missingCheckoutLink: "We couldn't find a payment link for this invoice. Please contact support.",
				accountRestricted: "Your account is restricted because the subscription is pending. Complete the payment to regain full access.",
			},
			checkoutPage: {
				steps: {
					data: "Data",
					customize: "Customize",
					review: "Review",
				},
				success: "Subscription completed successfully! Awaiting payment confirmation",
				closeToEnd: "Almost there!",
				BACK: "BACK",
				PAY: "PAY",
				NEXT: "NEXT",
				review: {
					title: "Subscription Summary",
					details: "Plan Details",
					users: "Users",
					whatsapp: "WhatsApp",
					charges: "Billing: Monthly",
					total: "Total",
				},
				form: {
					firstName: {
						label: "Full Name*",
						required: "Full name is required",
					},
					lastName: {
						label: "Last Name*",
						required: "Last name is required",
					},
					address1: {
						label: "Address*",
						required: "Address is required",
					},
					city: {
						label: "City*",
						required: "City is required",
					},
					state: {
						label: "State*",
						required: "State is required",
					},
					zipcode: {
						label: "ZIP Code*",
						required: "ZIP code is required",
						invalid: "Invalid ZIP code format",
					},
					country: {
						label: "Country*",
						required: "Country is required",
					},
					useAddressForPaymentDetails: {
						label: "Use this address for payment details",
					},
					invoiceId: {
						label: "Use this invoice ID",
					},
					nameOnCard: {
						label: "Name on Card*",
						required: "Name on card is required",
					},
					cardNumber: {
						label: "Card Number*",
						required: "Card number is required",
						invalid: "Invalid card number (ex: 4111111111111)",
					},
					expiryDate: {
						label: "Expiration Date*",
						required: "Expiration date is required",
						invalid: "Invalid expiration date"
					},
					cvv: {
						label: "CVV*",
						required: "CVV is required",
						invalid: "Invalid CVV (ex: 123)",
					},
				},
				pricing: {
					users: "Users",
					connection: "Connection",
					queues: "Queues",
					SELECT: "SELECT",
					month: "month",
				},
			},
			companies: {
				title: "Register Company",
				form: {
					name: "Company Name",
					plan: "Plan",
					token: "Token",
					submit: "Register",
					success: "Company created successfully!",
				},
			},
			auth: {
				toasts: {
					success: "Login successful!",
				},
				companyInactive: "Your company is inactive. Please finish the payment to regain full access.",
				companyOverdue: "Your subscription is overdue. Visit Finance to settle the payment.",
				token: "Token",
			},
			connections: {
				needsAttention: "needs attention",
				title: "Connections",
				toasts: {
					deleted: "WhatsApp connection deleted successfully!",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to scan the QR Code again.",
				},
				buttons: {
					add: "Add WhatsApp",
					disconnect: "disconnect",
					tryAgain: "Try again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connecting",
				},
				providerType: {
					label: "Connection Type",
					baileys: "WhatsApp Web",
					cloudApi: "WhatsApp API Oficial",
					official: "Official API"
				},
				toolTips: {
					disconnected: {
						title: "Failed to start WhatsApp session",
						content: "Make sure your phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code scan",
						content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session",
					},
					connected: {
						title: "Connection established!",
					},
					timeout: {
						title: "Connection to phone was lost",
						content: "Make sure your phone is connected to the internet and WhatsApp is open, or click the 'Disconnect' button to get a new QR Code",
					},
				},
				table: {
					name: "Name",
					status: "Status",
					lastUpdate: "Last update",
					default: "Default",
					actions: "Actions",
					session: "Session",
				},
			},
			whatsappModal: {
				title: {
					add: "Add WhatsApp",
					edit: "Edit WhatsApp",
				},
				formErrors: {
					name: {
						required: "Name is required",
						short: "Name is too short",
						long: "Name is too long",
					},
					cloudApiPhoneNumberId: {
						required: "Cloud API phone number is required",
					},
					cloudApiAccessToken: {
						required: "Cloud API access token is required",
					},
				},
				tabs: {
					general: "General",
					messages: "Messages",
					assessments: "Assessments",
					integrations: "Integrations",
					schedules: "Business Hours",
				},
				form: {
					name: "Name",
					default: "Default",
					sendIdQueue: "Queue",
					timeSendQueue: "Redirect to queue in X minutes",
					queueRedirection: "Queue Redirection",
					outOfHoursMessage: "Out of office message",
					queueRedirectionDesc: "Select a queue for contacts without a queue to be redirected to",
					prompt: "Prompt",
					queue: "Transfer Queue",
					timeToTransfer: "Transfer after x (minutes)",
					expiresTicket: "Close open chats after x minutes",
					expiresInactiveMessage: "Inactivity closure message",
					greetingMessage: "Greeting message",
					complationMessage: "Completion message",
					integration: "Integration",
					initialTag: "Initial tag",
					noInitialTag: "None",
					providerType: "Connection Type",
					cloudApiPhoneNumberId: "Cloud API phone number",
					cloudApiAccessToken: "Cloud API access token",
					cloudApiBusinessAccountId: "Business Account ID",
					cloudApiPhoneNumberIdHelp: "Use the Meta Phone Number ID (not the phone number).",
					cloudApiAccessTokenHelp: "Token is saved and hidden. Fill only to update it.",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCodeModal: {
				title: "Use your WhatsApp:",
				steps: {
					one: "1 - Open WhatsApp on your phone",
					two: {
						partOne: "2 - Tap More options on Android",
						partTwo: "or Settings",
						partThree: "on iPhone",
					},
					three: "3 - Tap Linked Devices and then Link a Device",
					four: "4 - Point your phone at this screen to capture the QR Code",
				},
				waiting: "Waiting for QR Code scan",
			},
			qrCode: {
				message: "Scan the QR Code to start the session",
			},
			contacts: {
				noResults: "No contacts found",
				title: "Contacts",
				toasts: {
					deleted: "Contact deleted successfully!",
					deletedAll: "All contacts deleted successfully!",
				},
				searchPlaceholder: "Search...",
				noContacts: "No contacts registered",
				confirmationModal: {
					deleteTitle: "Delete ",
					deleteAllTitle: "Delete All",
					importTitle: "Import contacts",
					importTitlte: "Import contacts",
					deleteMessage: "Are you sure you want to delete this contact? All related tickets will be lost.",
					deleteAllMessage: "Are you sure you want to delete all contacts? All related tickets will be lost.",
					importMessage: "Do you want to import all phone contacts?",
				},
				buttons: {
					import: "Import Contacts",
					add: "Add Contact",
					export: "Export Contacts",
					importShort: "Import",
					exportShort: "Export",
					delete: "Delete All Contacts",
					message: "Send message",
					edit: "Edit",
				},
				table: {
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
				},
			},
			contactImportModal: {
				title: "Contact Spreadsheet",
				labels: {
					import: "Import contacts",
					result: "results",
					added: "Added",
					savedContact: "Contact saved",
					errors: "Errors",
				},
				buttons: {
					download: "Download template spreadsheet",
					import: "Import contacts",
				},
			},
			queueIntegrationModal: {
				title: {
					add: "Add project",
					edit: "Edit project",
				},
				form: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project Name",
					language: "Language",
					jsonContent: "JsonContent",
					urlN8N: "URL",
					typebotSlug: "Typebot - Slug",
					typebotExpires: "Time in minutes to expire a conversation",
					typebotKeywordFinish: "Keyword to finish ticket",
					typebotKeywordRestart: "Keyword to restart flow",
					typebotRestartMessage: "Message when restarting conversation",
					typebotUnknownMessage: "Invalid option message",
					typebotDelayMessage: "Interval (ms) between messages",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					test: "Test Bot",
				},
				messages: {
					testSuccess: "Integration tested successfully!",
					addSuccess: "Integration added successfully.",
					editSuccess: "Integration edited successfully.",
				},
			},
			sideMenu: {
				name: "Initial Side Menu",
				note: "If enabled, the side menu will start closed",
				options: {
					enabled: "Open",
					disabled: "Closed",
				},
			},
			promptModal: {
				form: {
					name: "Name",
					prompt: "Prompt",
					model: "Model",
					max_tokens: "Maximum words in response",
					temperature: "Temperature",
					apikey: "API Key",
					max_messages: "Maximum messages in History",
					voice: "Voice",
					voiceKey: "Voice API Key",
					voiceRegion: "Voice Region",
					responseType: "Response type",
					responseTypeText: "Text",
					responseTypeVoice: "Voice",
					elevenLabsKey: "ElevenLabs Key",
					elevenLabsVoice: "ElevenLabs Voice",
				},
				formErrors: {
					name: {
						short: "Name is too short",
						long: "Name is too long",
						required: "Name is required",
					},
					prompt: {
						short: "Prompt is too short",
						required: "Describe the training for Artificial Intelligence",
					},
					model: {
						required: "Enter the desired model for the Prompt",
					},
					maxWords: {
						required: "Enter the maximum number of words in the response",
					},
					temperature: {
						required: "Enter the temperature",
					},
					apikey: {
						required: "Enter the API Key",
					},
					queueId: {
						required: "Enter the queue",
					},
					maxMessages: {
						required: "Enter the maximum number of messages in history",
					},
				},
				success: "Prompt saved successfully!",
				setor: "Enter the sector",
				title: {
					add: "Add Prompt",
					edit: "Edit Prompt",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
			},
			prompts: {
				title: "Prompts",
				table: {
					name: "Name",
					queue: "Sector/Queue",
					max_tokens: "Maximum Response Words",
					actions: "Actions",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone!",
				},
				buttons: {
					add: "Add Prompt",
				},
			},
			contactModal: {
				title: {
					add: "Add Contact",
					edit: "Edit Contact",
				},
				form: {
					mainInfo: "Contact Information",
					extraInfo: "Additional Information",
					name: "Name",
					number: "WhatsApp Number",
					email: "Email",
					extraName: "Field Name",
					extraValue: "Value",
					whatsapp: "Source Connection: ",
				},
				formErrors: {
					name: {
						required: "Name is required",
						short: "Name is too short",
						long: "Name is too long",
					},
					phone: {
						short: "Number is too short",
						long: "Number is too long",
					},
					email: {
						invalid: "Invalid email",
					},
				},
				buttons: {
					addExtraInfo: "Add Information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add Queue",
					edit: "Edit Queue",
				},
				form: {
					name: "Name",
					nameShort: "Short name",
					nameLong: "Long name",
					nameRequired: "Name is required",
					color: "Color",
					colorShort: "Short color",
					colorLong: "Long color",
					greetingMessage: "Greeting message",
					complationMessage: "Completion message",
					outOfHoursMessage: "Out of office message",
					ratingMessage: "Rating message",
					token: "Token",
					orderQueue: "Queue order (Bot)",
					integrationId: "Integration",
					initialTag: "Initial tag",
					noInitialTag: "None",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				toasts: {
					success: "Queue saved successfully.",
					info: "Click save to register changes",
				},
				tabs: {
					queueData: "Queue Data",
					attendanceTime: "Service Hours",
				},
			},
			avatarUpload: {
				title: "Change profile picture",
				selectImage: "Select an image to use as avatar",
				chooseFile: "Choose image",
				changeImage: "Choose another image",
				save: "Save",
				cancel: "Cancel",
				success: "Avatar updated successfully!",
				deleteSuccess: "Avatar removed successfully!",
				deleteAvatar: "Remove avatar",
				errors: {
					fileTooLarge: "File too large. Maximum 5MB.",
					invalidType: "Invalid file type. Use JPEG, PNG, GIF or WebP.",
				},
			},
			userModal: {
				title: {
					add: "Add User",
					edit: "Edit User",
				},
				changeAvatar: "Click to change photo",
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
					whatsapp: "Default Connection",
					allTicket: "All tickets",
					allTicketEnabled: "Enabled",
					allTicketDesabled: "Disabled",
					viewPendingTickets: "View mode",
					viewPendingTicketsEnabled: "Enabled",
					viewPendingTicketsDisabled: "Disabled",
					companyQuickMessages: "Company quick responses",
					companyQuickMessagesEnabled: "Enabled",
					companyQuickMessagesDisabled: "Disabled",
					allowTagEdit: "Tag editing",
					allowTagEditEnabled: "Enabled",
					allowTagEditDisabled: "Disabled",
				},
				formErrors: {
					name: {
						required: "Name is required",
						short: "Name is too short",
						long: "Name is too long",
					},
					password: {
						short: "Password is too short",
						long: "Password is too long",
					},
					email: {
						required: "Email is required",
						invalid: "Invalid email",
					},
				},
				labels: {
					liberations: "Releases",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			scheduleModal: {
				title: {
					add: "New Schedule",
					edit: "Edit Schedule",
				},
				form: {
					body: "Message",
					contact: "Contact",
					sendAt: "Schedule Date",
					sentAt: "Send Date",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				confirmationModal: {
					deleteTitle: "Delete Schedule",
					deleteMessage: "Are you sure you want to delete this schedule?",
				},
				success: "Schedule saved successfully.",
			},
			tagModal: {
				title: {
					add: "New Tag",
					edit: "Edit Tag",
				},
				form: {
					name: "Name",
					color: "Color",
					board: "Kanban Board",
					noBoard: "No board",
					showClosedTickets: "Include closed tickets in this Kanban stage",
					showClosedTicketsDisabledTooltip: "This board uses CRM Mode. Closed tickets leave the stage and appear in the Won or Lost tabs.",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Tag saved successfully.",
			},
			chat: {
				toasts: {
					fillTitle: "Please fill in the conversation title.",
					fillUser: "Please select at least one user.",
				},
				modal: {
					title: "Conversation",
					titleField: "Title",
				},
				confirm: {
					title: "Delete Conversation",
					message: "This action cannot be undone, confirm?",
				},
				chats: "Chats",
				messages: "Messages",
				noTicketMessage: "Select a ticket to start chatting.",
				buttons: {
					close: "Close",
					save: "Save",
					new: "New",
					newChat: "New",
				},
			},
			drafts: {
				label: "Draft",
			},
			uploads: {
				titles: {
					titleUploadMsgDragDrop: "DRAG AND DROP FILES IN THE FIELD BELOW",
					titleFileList: "File List",
				},
				toasts: {
					imageTooLarge: "Images can be up to {{limit}}MB.",
					videoTooLarge: "Videos can be up to {{limit}}MB.",
					audioTooLarge: "Audio files can be up to {{limit}}MB.",
					documentTooLarge: "Documents can be up to {{limit}}MB.",
					genericTooLarge: "The file exceeds the allowed limit.",
					fileTooLarge: "The file exceeds the allowed limit.",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				title: "Tickets",
				toasts: {
					deleted: "The service you were in has been deleted.",
					unauthorized: "Access not allowed",
				},
				filters: {
					user: "Filter by users",
					tags: "Filter by tags",
					userPlaceholder: "Users",
					tagsPlaceholder: "Tags",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Open" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages",
					sections: {
						tickets: "Tickets",
						messages: "Messages",
					},
					mediaChips: {
						photos: "Photos",
						videos: "Videos",
						links: "Links",
						documents: "Documents",
					},
				},
				buttons: {
					showAll: "All",
					unreadFirst: "Unread first",
				},
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Type to search users",
				fieldQueueLabel: "Transfer to queue",
				fieldQueuePlaceholder: "Select a queue",
				fieldConnectionLabel: "Transfer to connection",
				fieldConnectionPlaceholder: "Select a connection",
				noOptions: "No user found with that name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			ticketsList: {
				pendingHeader: "Waiting",
				assignedHeader: "In Progress",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No service found with this status or search term",
				buttons: {
					accept: "Accept",
					closed: "Finish",
					reopen: "Reopen",
				},
			},
			ticketsListItem: {
				tooltip: {
					chatbot: "Chatbot",
					peek: "Peek Conversation",
				},
				noQueue: "NO QUEUE",
			},
			ticketAdvanced: {
				selectTicket: "Select Ticket",
				ticketNav: "Ticket",
				attendanceNav: "Services",
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search contact",
				add: "Chat",
				searchQueueError: "An unexpected error occurred while trying to fetch queues",
				noQueue: "No queue",
				selectQueue: "Select a queue",
				selectConection: "Select a connection",
				defaultConnection: "Default connection",
				ticketReopened: "Ticket reopened successfully",
				contactNameLabel: "Contact name",
				contactNumberLabel: "Phone",
				contactNameRequired: "Please enter the contact name",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			ticket: {
				noQueue: "No queue",
				unknownUser: "Unknown user",
			},
			locationPreview: {
				button: "Preview",
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Connections",
					tickets: "Services",
					quickMessages: "Quick Responses",
					tasks: "Tasks",
					contacts: "Contacts",
					queues: "Queues & Chatbot",
					tags: "Tags",
					administration: "Administration",
					users: "Users",
					settings: "Settings",
					helps: "Help",
					messagesAPI: "API",
					schedules: "Activities",
					campaigns: "Triggers",
					flows: "Flowbuilder",
					annoucements: "Announcements",
					chats: "Internal Chat",
					management: "Management",
					financeiro: "Financial",
					files: "File List",
					prompts: "Open.AI",
					queueIntegration: "Integrations",
				},
				appBar: {
					refresh: "Reload page",
					notRegister: "No notifications",
					language: "Language",
					darkMode: "Dark Mode",
					lightMode: "Light Mode",
					greeting: {
						hello: "Hello",
						welcome: "Welcome to",
						active: "Active until",
					},
					user: {
						profile: "Profile",
						logout: "Logout",
					},
					internalComms: {
						title: "Internal Communication",
						chatTab: "Internal Chat",
						mentionsTab: "Mentions",
						noMentions: "No mentions",
						markAllRead: "Mark all as read",
					},
					mentions: {
						title: "Mentions",
					},
					activities: {
						title: "Reminders",
						empty: "No reminders for the next 24h",
						viewAll: "View all activities",
					},
				},
			},
			queueIntegration: {
				title: "Integrations",
				table: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project Name",
					language: "Language",
					lastUpdate: "Last update",
					actions: "Actions",
				},
				buttons: {
					add: "Add Project",
				},
				searchPlaceholder: "Search...",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone! It will be removed from linked queues and connections",
				},
			},
			files: {
				title: "File List",
				table: {
					name: "Name",
					contacts: "Contacts",
					actions: "Action",
				},
				toasts: {
					deleted: "List deleted successfully!",
					deletedAll: "All lists deleted successfully!",
				},
				buttons: {
					add: "Add",
					deleteAll: "Delete All",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteAllTitle: "Delete All",
					deleteMessage: "Are you sure you want to delete this list?",
					deleteAllMessage: "Are you sure you want to delete all lists?",
				},
			},
			messagesAPI: {
				title: "API",
				labels: {
					doc: "Documentation for sending messages",
					method: "Sending Methods",
					textMessage: "Text Message",
					mediaMessage: "Media Message",
					instructions: "Instructions",
					observations: "Important notes",
					before1: "Before sending messages, you need to register the token linked to the connection that will send the messages.",
					before2: "To register, access the 'Connections' menu, click the edit button of the connection and enter the token in the appropriate field.",
					numberDescription: "The sending number should not have masks or special characters and must be composed of:",
					countryCode: "Country Code",
					number: "Number",
					textMessage2: "1. Text Messages",
					textMessageInstructions: "Below is the list of information needed to send text messages:",
					method2: "Method",
					e: "and",
					tests: "Send Test",
					mediaMessage2: "2. Media Messages",
				},
				textMessage: {
					number: "Number",
					body: "Message",
					token: "Registered Token",
				},
				mediaMessage: {
					number: "Number",
					body: "File name",
					media: "File",
					token: "Registered Token",
				},
				toasts: {
					unauthorized: "This company doesn't have permission to access this page! We are redirecting you.",
					success: "Message sent successfully!",
				},
				buttons: {
					send: "Send",
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			quickMessages: {
				title: "Quick Responses",
				searchPlaceholder: "Search...",
				noAttachment: "No attachment",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action is irreversible! Do you want to proceed?",
				},
				buttons: {
					add: "Add",
					attach: "Attach File",
					cancel: "Cancel",
					edit: "Edit",
				},
				toasts: {
					success: "Shortcut added successfully!",
					deleted: "Shortcut removed successfully!",
				},
				dialog: {
					title: "Quick Message",
					shortcode: "Shortcut",
					message: "Response",
					save: "Save",
					cancel: "Cancel",
					add: "Add",
					edit: "Edit",
					availableForAll: "Available for everyone",
				},
				table: {
					shortcode: "Shortcut",
					message: "Message",
					actions: "Actions",
					mediaName: "File Name",
					status: "Status",
				},
				badges: {
					global: "Everyone",
					personal: "User",
				},
			},
			messageVariablesPicker: {
				label: "Available Variables",
				vars: {
					contactFirstName: "First Name",
					contactName: "Name",
					greeting: "Greeting",
					protocolNumber: "Protocol",
					date: "Date",
					hour: "Hour",
				},
			},
			contactLists: {
				title: "Contact Lists",
				table: {
					name: "Name",
					contacts: "Contacts",
					actions: "Actions",
				},
				buttons: {
					add: "New List",
				},
				dialog: {
					name: "Name",
					nameShort: "Short name",
					nameLong: "Long name",
					nameRequired: "Name is required",
					company: "Company",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					deleted: "Record deleted",
					success: "Operation completed successfully",
				},
				noListsFound: "No lists found",
				noListsCreated: "No contact lists created",
				tryOtherTerms: "Try searching with other terms",
				clickToCreate: "Click the button above to create your first list",
			},
			contactListItems: {
				title: "Contacts",
				searchPlaceholder: "Search...",
				buttons: {
					add: "New",
					lists: "Lists",
					import: "Import",
				},
				download: "Click here to download example spreadsheet.",
				dialog: {
					name: "Name",
					nameShort: "Short name",
					nameLong: "Long name",
					nameRequired: "Name is required",
					number: "Number",
					numberShort: "Short number",
					numberLong: "Long number",
					whatsapp: "WhatsApp",
					email: "Email",
					emailInvalid: "Invalid email",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				table: {
					name: "Name",
					number: "Number",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
					importMessage: "Do you want to import contacts from this spreadsheet? ",
					importTitle: "Import",
				},
				toasts: {
					deleted: "Record deleted",
				},
			},
			campaigns: {
				title: "Triggers",
				searchPlaceholder: "Search...",
				report: {
					title: "Report of",
					title2: "Campaign",
					of: "of",
					validContacts: "Valid contacts",
					delivered: "Delivered",
					connection: "Connection",
					contactList: "Contact List",
					schedule: "Schedule",
					conclusion: "Conclusion",
				},
				config: {
					interval: "Intervals",
					primaryIntervalTitle: "Primary random interval between messages",
					secondaryIntervalTitle: "Secondary random interval between messages",
					randomInterval: "Random Send Interval",
					biggerInterval: "Larger Interval After",
					greaterInterval: "Greater Send Interval",
					intervalMinLabel: "Sending interval (shorter)",
					intervalMaxLabel: "Sending interval (longer)",
					intervalRangeError: "The maximum interval must be greater than or equal to the minimum",
					noInterval: "No Interval",
					second: "second",
					seconds: "seconds",
					notDefined: "Not defined",
					addVariable: "Add Variable",
					save: "Save Settings",
					shortcut: "Shortcut",
					content: "Content",
					close: "Close",
					add: "Add",
				},
				buttons: {
					add: "New Trigger",
					contactLists: "Contact Lists",
				},
				status: {
					inactive: "Inactive",
					programmed: "Scheduled",
					inProgress: "In progress",
					canceled: "Canceled",
					finished: "Finished",
				},
				table: {
					name: "Name",
					whatsapp: "Connection",
					contactList: "Contact List",
					status: "Status",
					scheduledAt: "Schedule",
					completedAt: "Completed",
					confirmation: "Confirmation",
					actions: "Actions",
					notDefined: "Not defined",
					notDefined2: "Not defined",
					notScheduled: "Not scheduled",
					notConcluded: "Not concluded",
					stopCampaign: "Stop Campaign",
					startCampaign: "Start Campaign",
					pauseCampaign: "Pause Campaign",
					resetCampaign: "Restart Campaign",
				},
				dialog: {
					new: "New Trigger",
					update: "Edit Trigger",
					readonly: "View Only",
					form: {
						name: "Name",
						nameShort: "Short name",
						nameLong: "Long name",
						helper: "Use variables like {name}, {firstName}, {number}, {email} or define custom variables.",
						nameRequired: "Name is required",
						message1: "Message 1",
						message2: "Message 2",
						message3: "Message 3",
						message4: "Message 4",
						message5: "Message 5",
						messagePlaceholder: "Message content",
						whatsapp: "Connection",
						status: "Status",
						scheduledAt: "Schedule",
						confirmation: "Confirmation",
						contactList: "Contact List",
						tagList: "Inclusion Tag",
						tagInclude: "Inclusion Tag",
						tagExclude: "Exclusion Tag",
						fileList: "File List",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel Sends",
						start: "Start Sends",
						pause: "Pause Sends",
						reset: "Restart Sends",
						close: "Close",
						attach: "Attach File",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					configSaved: "Settings saved",
					success: "Operation completed successfully",
					cancel: "Campaign canceled",
					start: "Campaign started",
					pause: "Campaign paused",
					reset: "Campaign reset",
					restart: "Campaign restarted",
					deleted: "Record deleted",
				},
				noResults: "No results found",
				noCampaigns: "No campaigns created",
				active: "Active",
				inactive: "Disabled",
				editTooltip: "Edit campaign",
				deleteTooltip: "Delete campaign",
			},
			subscription: {
				title: "Subscription",
				validity: "Subscription validity",
				activeUntil: "Active until",
				expiredOn: "Expired on",
				noDueDate: "No due date",
				chargeEmail: "Billing email",
				signNow: "Sign up now!",
			},
			announcements: {
				active: "Active",
				inactive: "Inactive",
				title: "Announcements",
				searchPlaceholder: "Search...",
				high: "High",
				medium: "Medium",
				low: "Low",
				buttons: {
					add: "New Announcement",
					contactLists: "Announcement Lists",
				},
				table: {
					priority: "Priority",
					title: "Title",
					text: "Text",
					mediaName: "File",
					status: "Status",
					actions: "Actions",
				},
				dialog: {
					edit: "Edit Announcement",
					add: "New Announcement",
					update: "Edit Announcement",
					readonly: "View Only",
					form: {
						priority: "Priority",
						required: "Required field",
						title: "Title",
						text: "Text",
						mediaPath: "File",
						status: "Status",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel",
						close: "Close",
						attach: "Attach File",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					success: "Operation completed successfully",
					deleted: "Record deleted",
					info: "This company doesn't have permission to access this page! We are redirecting you.",
				},
			},
			campaignsConfig: {
				title: "Campaign Settings",
			},
			queues: {
				noResults: "No queues found",
				title: "Queues & Chatbot",
				noQueues: "No queues registered",
				table: {
					id: "ID",
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
					orderQueue: "Queue order (bot)",
				},
				buttons: {
					add: "Add queue",
					edit: "Edit",
					delete: "Delete",
				},
				toasts: {
					success: "Queue deleted successfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone! Services in this queue will continue to exist but won't have any queue assigned.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			users: {
				title: "Users",
				table: {
					id: "ID",
					name: "Name",
					email: "Email",
					profile: "Profile",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted successfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "All user data will be lost. Open services for this user will be moved to the queue.",
				},
			},
			tabletSearch: {
				open: "Search",
				clear: "Clear search",
				active: "Active search",
				results: "results",
				moreActions: "More actions",
			},
			todolist: {
				input: "New task",
				buttons: {
					add: "Add",
					save: "Save",
				},
			},
			helps: {
				title: "Help Center",
			},
			schedules: {
				noResultsWithFilters: "No results with the current filters",
				clearFilters: "Clear filters",
				title: "Activities",
				noResults: "No activities found",
				noSchedules: "No activities registered",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this Activity?",
					deleteMessage: "This action cannot be undone.",
					deleteTaskTitle: "Are you sure you want to delete this task?",
					deleteTaskMessage: "This action cannot be undone.",
				},
				table: {
					contact: "Contact",
					body: "Message",
					sendAt: "Schedule Date",
					sentAt: "Send Date",
					status: "Status",
					actions: "Actions",
				},
				messages: {
					date: "Date",
					time: "Time",
					event: "Event",
					allDay: "All Day",
					week: "Week",
					work_week: "Activities",
					day: "Day",
					month: "Month",
					previous: "Previous",
					next: "Next",
					yesterday: "Yesterday",
					tomorrow: "Tomorrow",
					today: "Today",
					agenda: "Agenda",
					noEventsInRange: "No activities in this period.",
					showMore: "more",
				},
				activityTypes: {
					call: "Call",
					meeting: "Meeting",
					message: "Message",
					email: "Email",
					visit: "Visit",
					activity: "Task",
				},
				buttons: {
					add: "New Activity",
					edit: "Edit",
					delete: "Delete",
				},
				filters: {
					allUsers: "All",
					allTypes: "All",
				},
				tooltips: {
					viewDescription: "View description",
				},
				activityTypes: {
					call: "Call",
					meeting: "Meeting",
					message: "Message",
					email: "Email",
					visit: "Visit",
					activity: "Task",
					confirmationModal: {
						deleteTitle: "Delete Activity Type",
						deleteMessage: "Are you sure you want to delete this activity type?",
					},
					toasts: {
						created: "Activity type created!",
						updated: "Activity type updated!",
						deleted: "Activity type deleted!",
					},
				},
				statuses: {
					schedule: {
						sent: "Sent",
						error: "Error",
						late: "Late",
						soon: "Soon",
						scheduled: "Scheduled",
					},
					task: {
						done: "Completed",
						late: "Overdue",
						soon: "Soon",
						pending: "Pending",
					},
				},
				activityModal: {
					title: "New Activity",
					editTitle: "Edit Activity",
					editScheduleTitle: "Edit Schedule",
					board: "Board",
					allBoards: "All",
					type: "Type",
					connection: "Connection",
					contact: "Contact",
						description: "Description",
						message: "Message",
						when: "Date/Time",
						attachment: "Attach",
						cancel: "Cancel",
						save: "Save",
				},
				views: {
					list: "List",
					calendar: "Calendar",
				},
				toasts: {
					deleted: "Activity deleted successfully.",
					created: "Activity created successfully.",
					ticketNotFound: "Activity not created because the ticket does not exist.",
				},
			},
			task: {
				title: "Edit task",
				form: {
					description: "Describe the activity...",
					when: "When?",
				},
				toasts: {
					deleted: "Task deleted successfully.",
				},
				success: "Task saved successfully!",
				error: "Error saving task!",
			},
			flowBuilderTransferencia: {
				title: "Configure Connection Transfer",
				save: "Save",
				cancel: "Cancel",
				destination: "Transfer Destination",
				destinationConnection: "Destination Connection",
				destinationQueue: "Destination Queue (Optional)",
				noQueue: "No Queue",
				options: "Transfer Options",
				sendMessages: "Send messages (\"Transferring service...\" and \"Service transferred successfully.\")",
				keepTags: "Keep existing ticket tags",
				infoTitle: "How it works:",
				infoLine1: "The current ticket will be closed on the source connection",
				infoLine2: "A new ticket will be created/reopened on the destination connection",
				infoLine3: "The flow context will be maintained and continue on the destination ticket",
				infoLine4: "Previously collected messages will be preserved",
				selectConnection: "Select a destination connection",
				connected: "Connected",
				disconnected: "Disconnected",
			},
			flowBuilderMenuModal: {
				explanationMessage: "Menu explanation message",
				addOption: "Add Option",
				typeN: "Type {{number}}",
				typeOption: "Type option",
				optionsFormat: "Options format",
				formatDot: "1. Option",
				formatDash: "1 - Option",
				formatBrackets: "[1] Option",
				formatEmoji: "1️⃣ Option",
				titleAdd: "Add menu to flow",
				titleEdit: "Edit menu",
				buttonAdd: "Add",
				buttonSave: "Save",
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this Tag?",
					deleteMessage: "This action cannot be undone.",
					deleteAllMessage: "Are you sure you want to delete all Tags?",
					deleteAllTitle: "Delete All",
				},
				table: {
					name: "Name",
					color: "Color",
					tickets: "Tagged Records",
					actions: "Actions",
				},
				buttons: {
					delete: "Delete tag",
					add: "New Tag",
					deleteAll: "Delete All",
				},
				toasts: {
					deletedAll: "All Tags deleted successfully!",
					deleted: "Tag deleted successfully.",
				},
				noResults: "No results found",
				noTags: "No tags created",
			},
			settings: {
				schedulesUpdated: "Schedules updated successfully.",
				success: "Settings saved successfully.",
				title: "Settings",
				tabs: {
					services: "Services",
					options: "Options",
					schedules: "Schedules",
					companies: "Companies",
					plans: "Plans",
					billing: "Billing",
					helps: "Help",
				},
				options: {
					toasts: {
						success: "Operation updated successfully.",
						error: "Could not save the setting.",
					},
					fields: {
						ratings: {
							title: "Ratings",
							disabled: "Disabled",
							enabled: "Enabled",
						},
						expedientManager: {
							title: "Business Hours Management",
							queue: "Queue",
							company: "Company",
						},
						ignoreMessages: {
							title: "Ignore Group Messages",
						},
						acceptCall: {
							title: "Accept Call",
							disabled: "Don't accept",
							enabled: "Accept",
						},
						chatbotType: {
							title: "Chatbot Type",
							text: "Text",
						},
						language: {
							title: "Language",
						},
						sendGreetingAccepted: {
							title: "Send greeting when accepting ticket",
						},
						sendMsgTransfTicket: {
							title: "Send message on transfer",
						},
						sendGreetingMessageOneQueues: {
							title: "Send greeting when there's only 1 queue",
						},
						disabled: "Disabled",
						active: "Active",
						enabled: "Enabled",
					},
					updating: "Updating...",
					tabs: {
						integrations: "INTEGRATIONS",
					},
				},
				helps: {
					toasts: {
						errorList: "Could not load records list",
						errorOperation: "Could not complete operation",
						error: "Could not complete operation. Check if help with the same name exists or if fields were filled correctly",
						success: "Operation completed successfully!",
					},
					buttons: {
						clean: "Clear",
						delete: "Delete",
						save: "Save",
					},
					grid: {
						title: "Title",
						description: "Description",
						video: "Video",
					},
					confirmModal: {
						title: "Delete Record",
						confirm: "Do you really want to delete this record?",
					},
				},
				company: {
					newCompany: "New Company",
					editCompany: "Edit Company",
					subscriptionSection: "Plan and subscription",
					planChange: {
                        financeUnavailable: "Asaas is not configured to retrieve payments and subscriptions.",
                        financeLoadError: "Could not retrieve financial data. Please try again.",
                        retryFinance: "Try again",

						title: "Review plan change", company: "Company", current: "Current plan", target: "New plan",
						cycleValue: "Amount per cycle", usage: "Current usage and new plan limits",
						users: "Users", connections: "Connections", queues: "Queues", blocked: "Current usage exceeds the new plan limit:",
						featuresLost: "Features that will no longer be available", back: "Back", confirm: "Confirm", applying: "Confirming…",
						editCompany: "Edit company", separatePassword: "Save the password change separately before changing the plan.",
						previewError: "Could not prepare the review. Check the plan and the company's billing details.",
						confirmError: "Could not confirm the change. Review the details and try again.",
						rejected: "The change was not applied. Review the details before trying again.",
						statusError: "Could not verify the change. Try again or contact support before starting another.",
						storageError: "Could not save the change identifier in this browser.",
						                        paidCycle: "Paid cycle: from {{start}} until renewal on {{end}}.",
                        nextCycle: "Next cycle",
                        newCharge: "New payment",
                        newCycleValue: "Full cycle of the new plan",
                        unusedCredit: "Credit: {{count}} of {{total}} unused days",
                        amountDue: "Amount due",
                        paymentDue: "Due date",
                        upgradeActivation: "New plan after payment",
                        upgradeExplanation: "Payment is due on the day after the request. Confirmed payment activates the new plan and starts a full cycle on that date. The credit is fixed for this request; current paid coverage and the usual grace period still apply while you wait.",
                        downgradeActivation: "Change on {{date}}",
                        downgradeExplanation: "The current plan continues until the paid cycle ends. The new plan takes effect at the boundary after checking resource limits. There is no credit for this reduction; access in the next cycle depends on payment, with the usual grace period.",
                        fullRenewal: "Subsequent renewals cost the full {{value}} per cycle.",
                        downgradeLimits: "Reduce usage before the effective date. The change will require review if these limits are still exceeded:",
                        awaitingPayment: "Awaiting payment",
                        scheduled: "Change scheduled for {{date}}",
                        reviewRequired: "Review required",
                        verifying: "Checking request",
                        lookupFailed: "Could not retrieve the request",
                        requestFor: "Plan change for",
                        openCharge: "Open payment",
                        pendingCharge: "Payment of {{value}} due on {{date}}.",
                        awaitingExplanation: "The current plan remains until payment is confirmed, subject to paid coverage and the usual grace period.",
                        scheduledExplanation: "The current plan continues until {{date}}. The change and resource limits will be checked on that date.",
                        assignedExplanation: "The {{plan}} plan has been applied. The new usage cycle awaits confirmed payment, with the usual grace period.",
                        limitReview: "Usage exceeds the new plan limits. Reduce users, connections or queues and check again. No resources have been deleted.",
                        reviewExplanation: "This change requires financial review. Check its status before starting another request.",
                        otherAdministrator: "Another administrator confirmed this request. You can check its status; the system continues processing it.",
                        companyNumber: "Company {{id}}",
                        pendingOperation: "This company already has a pending plan change. Check its status before starting another.",
                        checkStatus: "Check and resume",
                        useCampaigns: "Campaigns", useSchedules: "Schedules", useInternalChat: "Internal chat", useExternalApi: "External API", useKanban: "Kanban", useOpenAi: "OpenAI", useAutomation: "Automations", useIntegrations: "Integrations"
					},
					toasts: {
						errorList: "Could not load records list",
						errorOperation: "Could not complete operation",
						error: "Could not complete operation. Check if company with same name exists or if fields were filled correctly",
						success: "Operation completed successfully!",
					},
					confirmModal: {
						title: "Delete Record",
						confirm: "Do you really want to delete this record?",
						message: "Are you sure you want to delete this company?",
					},
					form: {
						cpfCnpj: "CPF/CNPJ",
						cpfCnpjRequired: "CPF/CNPJ is required",
						cpfCnpjInvalid: "Invalid CPF/CNPJ",
						name: "Name",
						email: "Email",
						phone: "Phone",
						plan: "Plan",
						status: "Status",
						trial: "Trial",
						active: "Active",
						yes: "Yes",
						no: "No",
						campanhas: "Campaigns",
						enabled: "Enabled",
						disabled: "Disabled",
						dueDate: "Due date",
						recurrence: "Recurrence",
						monthly: "Monthly",
						expire: "Expiration",
						createdAt: "Created On",
					},
					buttons: {
						cancel: "Cancel",
						clear: "Clear",
						delete: "Delete",
						expire: "+ Expiration",
						user: "User",
						save: "Save",
					},
				},
				schedules: {
					form: {
						weekday: "Weekday",
						initialHour: "Start Time",
						finalHour: "End Time",
						save: "Save",
					},
				},
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
						download: "Download",
						options: "Options",
					},
				},
				today: "Today",
				yesterday: "Yesterday",
				quotedMessageNotFound: "Quoted message not found",
				goToQuotedMessage: "Go to the quoted message",
				audioSpeed: "Audio speed: {{speed}}x",
				lostCall: "Missed voice/video call at",
				deletedMessage: "This message was deleted by the contact",
				edited: "Edited",
				saudation: "Say hello to your new contact!",
				internalNoteBy: "Note by {{author}}",
				internalNoteAuthor: "Team",
				noteRemoved: "Note removed successfully!",
				transferNote: {
					viewTicket: "View ticket #{{id}}",
					viewPreviousTicket: "View previous ticket (#{{id}})",
				},
				vcard: {
					startConversation: "Start chat",
					multipleContacts: "This card contains {{count}} contacts. Choose one to start the chat.",
					noPhoneFound: "We couldn't find a valid phone number in this contact card.",
					ticketCreated: "Ticket created from the contact card.",
					ticketCreatedMultiple: "Ticket created for {{contact}}.",
					ticketAlreadyOpen: "An open ticket already exists for this contact. Taking you there.",
					missingUserOwner: "We couldn't identify who should own the ticket to continue the conversation."
				},
				interactiveButtons: {
					title: "Message with buttons",
				},
				interactiveList: {
					title: "Message with list",
					viewOptions: "View options",
				},
			},
			messagesInput: {
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
				sendMessage: "Send message",
				sendFile: "Send file",
				attachMenu: {
					title: "Attach",
					file: "File",
					contact: "Contact",
					signature: "Signature",
				},
				contactDialog: {
					title: "Send contact",
					search: "Search contact by name",
					empty: "No contacts found",
					cancel: "Cancel",
					unknown: "Unnamed contact",
					missingNumber: "This contact doesn't have a valid number.",
				},
				recordAudio: "Record audio",
				noteToggle: "Note",
				placeholderNote: "Write an internal note",
				placeholderEditing: "Edit the message and press Enter to save.",
				saveNote: "Save note",
				noteSaved: "Note saved successfully!",
				noteError: "Could not save the note",
				ticketNotOpen: "This ticket is not open. Cannot send messages.",
				clearReply: "Clear reply",
				cancelRecording: "Cancel recording",
				sendAudio: "Send audio",
				cancelUpload: "Cancel upload",
				sendErrorPending: "We couldn't send it now. The message will stay pending.",
				replyPreview: {
					location: "Location",
					contact: "Contact",
					contacts: "{{count}} contacts"
				},
				editingMode: "Editing message",
				saveEdit: "Save edit",
				cancelEdit: "Cancel edit",
			},
			contactDrawer: {
				header: "Contact Information",
				buttons: {
					edit: "Edit contact",
				},
				extraInfo: "Other information",
			},
			contactDocuments: {
				status: {
					pending: "Pending",
					signed: "Completed",
					rejected: "Rejected",
				},
			},
			fileModal: {
				title: {
					add: "Add file list",
					edit: "Edit file list",
				},
				buttons: {
					okAdd: "Save",
					okEdit: "Edit",
					cancel: "Cancel",
					fileOptions: "Add file",
				},
				form: {
					name: "File list name",
					message: "List details",
					fileOptions: "File list",
					extraName: "Message to send with file",
					extraValue: "Option value",
				},
				formErrors: {
					name: {
						required: "Name is required",
						short: "Name is too short",
					},
					message: {
						required: "Message is required",
					},
				},
				success: "File list saved successfully!",
			},
			ticketOptionsMenu: {
				schedule: "Schedule",
				delete: "Delete",
				transfer: "Transfer",
				exportHistory: "Save history",
				exportSuccess: "History exported successfully!",
				registerAppointment: "Contact Notes",
				appointmentsModal: {
					title: "Contact Notes",
					textarea: "Note",
					placeholder: "Enter the information you want to record here",
				},
				confirmationModal: {
					title: "Delete ticket",
					titleFrom: "from contact ",
					message: "Warning! All messages related to this ticket will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				reply: "Reply",
				edit: "Edit",
				react: "React",
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be undone.",
				},
				editModal: {
					title: "Edit message",
					placeholder: "Type the new message...",
					save: "Save",
					cancel: "Cancel",
				},
				editErrors: {
					windowExpired: "Edit time limit expired (15 minutes)",
					mediaMessage: "Media messages cannot be edited",
					notFromMe: "Only messages sent by you can be edited",
					emptyMessage: "Message cannot be empty",
					genericError: "Could not edit the message",
				},
			},
			backendErrors: {
        ERR_COMPANY_CPF_CNPJ_REQUIRED: "CPF/CNPJ is required.",
        ERR_COMPANY_INVALID_CPF_CNPJ: "Invalid CPF/CNPJ. Check the number.",
        ERR_COMPANY_CPF_CNPJ_REJECTED: "Asaas refused this CPF/CNPJ. Check the number and try again.",
        ERR_COMPANY_CPF_CNPJ_SYNC_FAILED: "The CPF/CNPJ could not be updated in Asaas. Try again.",
        ERR_PLAN_CHANGE_CUSTOMER_DOCUMENT_REQUIRED: "Enter the company CPF/CNPJ to continue with the upgrade.",
        ERR_PLAN_CHANGE_PROVIDER_REJECTED: "Asaas refused the charge and nothing was issued. Review the company details and try again.",
        ERR_OPENAI_MODEL_UNSUPPORTED: "Unknown AI model. Select GPT 6 Luna, GPT 6.1 Sol or GPT 6 Astra.",
					ERR_SUPPORT_BETA_EXTERNAL_ACTION_DISABLED: "This action is disabled in this testing environment.",
				ERR_INTERNAL_SERVER_ERROR: "An unexpected error occurred. Please try again later",
				ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
				ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check the connections page.",
				ERR_WAPP_NOT_INITIALIZED: "This WhatsApp session hasn't been initialized. Check the connections page.",
				ERR_CLOUD_API_CONNECT_FAILED: "Failed to connect to the official WhatsApp API. Check your credentials.",
				ERR_WAPP_CHECK_CONTACT: "Couldn't verify WhatsApp contact. Check the connections page",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
				ERR_WAPP_DOWNLOAD_MEDIA: "Couldn't download WhatsApp media. Check the connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_USER_DONT_EXISTS: "User not found. Check the provided email.",
				ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check the connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete WhatsApp message.",
				ERR_OTHER_OPEN_TICKET: "There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please log in.",
				ERR_SESSION_REVOKED: "Your session was closed because there was a login from another device.",
				ERR_NO_AUTH_TOKEN: "Session not found. Please log in again.",
				ERR_INVALID_ACCESS_TOKEN: "Invalid access token. Trying to renew your session.",
				ERR_USER_CREATION_DISABLED: "User creation has been disabled by the administrator.",
				ERR_KANBAN_EXECUTION_MODE_INVALID: "Choose a valid execution mode in the Add to Kanban action.",
				ERR_KANBAN_EXECUTION_MODE_MIXED: "Use the same execution mode for every Add to Kanban action in this sequence.",
				ERR_KANBAN_CARD_TITLE_TEMPLATE_INVALID: "The Card name template contains an invalid variable or format.",
				ERR_KANBAN_CARD_TITLE_TOO_LONG: "The resulting Card name exceeds the 255-character limit.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_NO_SETTING_FOUND: "No settings found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error creating message in database.",
				ERR_CREATING_TICKET: "Error creating ticket in database.",
				ERR_FETCH_WAPP_MSG: "Error fetching WhatsApp message, it might be too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, choose another.",
				ERR_WAPP_GREETING_REQUIRED: "Greeting message is required when there is more than one queue.",
				ERR_FILE_TOO_LARGE: "File exceeds the allowed limit.",
				ERR_MEDIA_IMAGE_TOO_LARGE: "Images can be up to {{limit}}MB.",
				ERR_MEDIA_VIDEO_TOO_LARGE: "Videos can be up to {{limit}}MB.",
				ERR_MEDIA_AUDIO_TOO_LARGE: "Audio files can be up to {{limit}}MB.",
				ERR_MEDIA_DOCUMENT_TOO_LARGE: "Documents can be up to {{limit}}MB.",
				ERR_CAMPAIGN_MEDIA_REQUIRED: "This campaign requires an attached media file. Attach an image before starting.",
				ERR_INVALID_NUMBER_FORMAT: "Invalid number format. Number must have at least 8 digits.",
				ERR_NOT_BRAZILIAN_NUMBER: "Invalid international number. Could not verify this number on WhatsApp.",
				ERR_INVALID_DDD: "Invalid area code. The code must be between 11 and 99.",
				ERR_INVALID_WHATSAPP_NUMBER: "Invalid WhatsApp number. Check if the number is correct and has an active WhatsApp account.",
				ERR_NO_QUEUE_ACCESS: "No permission to access queue {{queueName}}",
				ERR_TICKET_ASSIGNED_OTHER_USER: "Ticket assigned to {{userName}}",
				ERR_PENDING_TICKET_READONLY: "Ticket is in pending mode. Cannot send messages.",
				ERR_CLOSED_TICKET: "This ticket is closed. Cannot send messages. Please reopen the ticket first.",
				ERR_TRANSFER_VIEW_TARGET_REQUIRED: "Unable to identify the ticket linked to this transfer.",
				ERR_TRANSFER_VIEW_INVALID_SOURCE: "Invalid source ticket for transfer view.",
				ERR_TRANSFER_VIEW_INVALID_TARGET: "Invalid related ticket for transfer view.",
				ERR_TRANSFER_VIEW_SOURCE_NOT_FOUND: "The source ticket for this transfer was not found.",
				ERR_TRANSFER_VIEW_TARGET_NOT_FOUND: "The related ticket for this transfer was not found.",
				ERR_TRANSFER_VIEW_FORBIDDEN: "You do not have permission to view this transferred ticket history."
			},
		}
	},
	documentModal: {
		title: "Send Document for Signature",
		documentInfo: "Document Information",
		documentTitleLabel: "Document Title",
		signers: "Signers",
		signerLabel: "Signer",
		signerNameLabel: "Signer Name",
		emailLabel: "Email",
		whatsappLabel: "WhatsApp",
		whatsappTooltipPrimary: "Enter WhatsApp to send the link.",
		whatsappTooltipSecondary: "Enter WhatsApp to send the link.",
		addSigner: "Add signer",
		documentOptions: "Document Options",
		orderLabel: "Order",
		enabled: "Enabled",
		disabled: "Disabled",
		visibleSignatureLabel: "Visible signature",
		signatureAppearanceLabel: "Signature style",
		signatureAppearanceDefault: "Default",
		sendMethodLabel: "Delivery method",
		sendMethodLink: "Link",
		sendMethodEmail: "Email",
		sendMethodWhatsapp: "WhatsApp",
		footerLabel: "Footer",
		footerNone: "No footer",
		folderSection: "File & Folder",
		folderTypeLabel: "Folder type",
		folderLabel: "Folder",
		folderNone: "Default (Root)",
		folderEmpty: "No folder available",
		newFolderLabel: "New Folder",
		folderTypeRegular: "My Folders",
		folderTypeOrganization: "Organization Folders",
		createFolderSuccess: "Folder created successfully!",
		createFolderError: "Error creating folder",
		loadFolderError: "Error loading folders"
	},
};

export { messages };
